import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import { trackPage } from './utils/analytics'

// Create Pinia store before app initialization
const pinia = createPinia()
const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://cff3acf7d4fa83f9f2cba83abcb36978@o4508942047117312.ingest.us.sentry.io/4508942048821248',
  environment: import.meta.env.VITE_SENTRY_ENV || 'development', // Fallback to 'development'
  
  // Enable automatic instrumentation with browser tracing
  integrations: [Sentry.browserTracingIntegration()],
  
  // Configure trace sample rate - adjust based on environment
  // Use environment variable if available, otherwise use 1.0 for development and 0.2 for production
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE ? 
    parseFloat(import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE) : 
    (import.meta.env.VITE_SENTRY_ENV === 'production' ? 0.2 : 1.0),
  
  // Set trace propagation targets to control which URLs are traced
  tracePropagationTargets: [
    "localhost", 
    /^\//,                  // All relative URLs
    /^https:\/\/prod-1-data\.ke\.pinecone\.io/  // Pinecone API endpoints
  ]
})

// Use Pinia store
app.use(pinia)

// Track initial page view after mount
app.mount('#app')

// Track the initial page view
// Note: The Segment script in index.html already tracks the initial page,
// but we're adding this to ensure consistency if the script loading is delayed
trackPage('Home')
